import * as React from 'react';
import { Introduction } from '../IntroductionRedesigned';
import { Responsive } from '@cian/ui-kit';
import { StickyBottomLayout } from '../../components/StickyBottomLayout';
import { MobileCall } from '../MobileCall';
import { FixedHeader } from '../FixedHeaderRedesign';
import { Facts } from '../Facts';
import { ContentWrapper } from '../../components/ContentWrapper/';
import { AboutRedesigned } from '../About';
import { Ratings, Awards } from '../Awards';
import { OtherDevelopers } from '../OtherDevelopersRedesigned';
import { SpecialPromoRedesign } from '../SpecialPromoRedesign';
import { ProjectsRedesigned } from '../Projects';
import { ProjectsOnMap } from '../ProjectsOnMap/ProjectsOnMapRedesigned';
import { ReliabilityContainer } from '../ReliabilityContainer';
import { Reviews } from '../Reviews';

export const PageRedesigned = () => {
  return (
    <div data-testid="PageRedesigned">
      <Responsive desktop>
        <FixedHeader />
      </Responsive>
      <Introduction />
      <Facts />
      <ContentWrapper>
        <AboutRedesigned />
        <Responsive tablet phone>
          <ReliabilityContainer />
        </Responsive>
        <Ratings />
        <Awards />
        <SpecialPromoRedesign />
        <ProjectsRedesigned />
        <ProjectsOnMap />
        <Reviews />
        <OtherDevelopers />
      </ContentWrapper>
      <Responsive tablet phone>
        <StickyBottomLayout>
          <MobileCall />
        </StickyBottomLayout>
      </Responsive>
    </div>
  );
};
